// extracted by mini-css-extract-plugin
export var linkText = "_pb-0";